export const formatTimeMixin = {

    methods: {
        formatTime(val) {
            var date = new Date(val)
            let str = date.getFullYear()
            let mon = date.getMonth() + 1
            str += "-"
            str += (mon > 9) ? mon.toString() :  "0" + mon
            str += "-"
            str += (date.getDate() > 9) ? date.getDate().toString() :  "0" + date.getDate()
            str += " "
            str += (date.getHours() > 9) ? date.getHours().toString() :  "0" + date.getHours()
            str += ":"
            str += (date.getMinutes() > 9) ? date.getMinutes().toString() :  "0" + date.getMinutes()
            str += ":"
            str += (date.getSeconds() > 9) ? date.getSeconds().toString() :  "0" + date.getSeconds()
            return str
        },
    }
}
export const logCommonData = {
    data() {
        return {
            pickerOptions: {
                shortcuts: [{
                    text: '最近一天',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            downloadLoading: false,
            dateValue: [new Date(new Date() - 3600 * 1000 * 24), new Date()],
        }
    },

    methods: {
        /* 当前页改变 */
        currentChangeHandle(val) {
            this.page.startPage = val
            this.getLogList()
        },
        /* 每页条数改变 */
        sizeChangeHandle(val) {
            this.page.limit = val
            this.getLogList()
        },
        /* 获取选中的数据 */
        handleSelectionChange(val) {
            this.multipleSelection = val
        },
        /* 表单击行事件 */
        checkRow(r, c, e) {
            this.$refs.multipleTable.toggleRowSelection(r)
        },
    }
}

export const commonData = {
    data() {
        return {
            page: { // 分页参数
                startPage: 1,
                limit: 10
            },
            tableHeight: 0,
            multipleSelection: [], // 选中的对象列表
            info: {
                success: false,
                list: [],
                total: 0
            },
        }
    }
}